import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import {
  GET_PARALLELS_LIST,
  convertParams,
  convertResult,
} from 'app/common/api/requests/reports/parallels_list/get'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { api } from 'app/api'

import { orgsFilterSelection } from './orgsFilter'
import { schoolYearFilterSelection } from './schoolYearFilter'

type ParallelsList = ItemType[]

class ParallelsFilterDataBox extends DataBox<ParallelsList> {}

export const defaultParallels: ParallelsList = []
export const parallelsFilter = createDataBox(
  'parallelsFilter',
  defaultParallels,
  ParallelsFilterDataBox,
)

export const defaultParallelsDataReceiver = async () => {
  const [schoolId] = orgsFilterSelection.getData()
  const [schoolYearId] = schoolYearFilterSelection.getData()
  if (!schoolId || !schoolYearId) return []

  const res = await api.request(GET_PARALLELS_LIST, {
    error: 'Не удалось получить данные параллелей',
    params: {
      schoolId,
      schoolYearId,
    },
    convertions: {
      convertParams,
      convertResult,
    },
  })

  return res ? res.map((parallel) => ({ id: String(parallel), title: String(parallel) })) : []
}

export const defaultParallelsSelection: string[] = []
export const parallelsFilterSelection = createDataBoxDefault<string[]>(
  'parallelsFilterSelection',
  defaultParallelsSelection,
)
